import React from 'react';
import { Bone } from '../Bone/Bone';
import './ProviderCardSkeleton.css';

export interface ProviderCardSkeletonProps {
  /** A Connected card ends in its trash; a catalog card in its Connect. */
  variant: 'connected' | 'catalog';
}

/** A provider card while it loads: logo, name and status line, and what closes the row. */
export function ProviderCardSkeleton({ variant }: ProviderCardSkeletonProps): React.ReactElement {
  return (
    <div className="integrations-card-skeleton">
      <Bone className="integrations-card-skeleton__logo" />
      <div className="integrations-card-skeleton__body">
        <Bone className="integrations-card-skeleton__name" />
        <Bone className="integrations-card-skeleton__meta" />
      </div>
      {variant === 'connected' ? (
        <Bone className="integrations-card-skeleton__trash" />
      ) : (
        <Bone className="integrations-card-skeleton__cta" />
      )}
    </div>
  );
}
